export const NAVIGATION_PATHS = {
  PROGRAMMATIC: '/deals/programmatic',
  DIRECT_SALES: '/deals/direct-sales',
  PRODUCT_MANAGEMENT: '/deals/product-management',
  CONTENT_MANAGEMENT: '/content-management',
  INSIGHTS: '/insights',
  ADMINISTRATION: '/administration/creatives',
  INVENTORY_MANAGEMENT: '/inventory-management',
  AVAILABILITY_REPORT: '/availability',
};
